import { dateToShow } from '@/helpers/dates'
import { get } from 'lodash'

const apiN1 = get(process.env, 'API_NODE_URL')
const prepareShow = covenant => {
  covenant.birthdate = dateToShow(covenant.birthdate)
  return covenant
}

export default {
  prepareShow,
  getAllCovenants () {
    const getCovenant = {
      fieldId: 'id',
      fieldText: 'name',
      table: 'covenants',
      order: 'name'
    }
    this.$apin1.post(apiN1 + '/components/select', getCovenant)
      .then(function (response) {
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/settings/covenants/resources/methods.js